import React, { useState } from "react";
import { WrapperSeamless } from "../../layout-components";
import Table from "../../components/tables/table";
import { Button } from "@material-ui/core";
import { useGetList } from "../../hooks";
import { Link } from "react-router-dom";
import * as Api from "../../service";
import useStore from "../../context";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { useTranslation } from "localization/translation";
import { Select, CopyButton } from "../../components";

const ACTIVE_FILTER_OPTIONS = [
  { id: "true", name: "active" },
  { id: "false", name: "inactive" },
];

const COUNTRIES_QUERY = {
  sort: "name_en",
  order: "asc",
};

export default function DealerCodesList() {
  const { setRemove, lang } = useStore();
  const translation = useTranslation();
  const [query, setQuery] = useState({
    sort: "created_at",
    order: "desc",
  });

  const [items, total, refresh, setItems] = useGetList(
    Api.dealerCodes.getAll,
    query
  );
  const [countries] = useGetList(Api.countries.getAll, COUNTRIES_QUERY);

  const countryNameField = `name_${lang || "en"}`;

  const rows = items?.map((item) => (
    <>
      <td className="text-left px-4">
        <div className="d-flex align-items-center">
          <div className="font-size-sm font-weight-bold">{item.code}</div>
          <CopyButton text={item.code} />
        </div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm">{item.name}</div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm">
          {item.country?.[countryNameField] ||
            item.country?.name_en ||
            "—"}
        </div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm">
          {item.is_active ? translation.active : translation.inactive}
        </div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm">{item.users_count ?? 0}</div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm">{item.notes || "—"}</div>
      </td>
      <td className="text-right actions_filed">
        <Link to={`/dealer-codes/create/${item.id}`}>
          <Button className="btn-neutral-first mx-1 shadow-none d-30 border-0 p-0 d-inline-flex align-items-center justify-content-center">
            <EditIcon color="primary" />
          </Button>
        </Link>

        <Button
          onClick={() =>
            setRemove(() => () => Api.dealerCodes.delete(item.id).then(refresh))
          }
          className="btn-neutral-danger mx-1 shadow-none d-30 border-0 p-0 d-inline-flex align-items-center justify-content-center"
        >
          <DeleteIcon color="error" />
        </Button>
      </td>
    </>
  ));

  return (
    <WrapperSeamless>
      <Table
        fields={
          <>
            <th className="text-left px-4">
              <span className="mr-3">{translation.code}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.name}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.country}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.is_active}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.users_count}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.notes}</span>
            </th>
          </>
        }
        header={
          <div className="table-header-filters">
            <Select
              onChange={(val) =>
                setQuery((st) => {
                  const next = { sort: st.sort, order: st.order };
                  if (st.active) next.active = st.active;
                  if (val) next.country_id = val;
                  return next;
                })
              }
              value={query.country_id || ""}
              field={countryNameField}
              label={translation.country}
              options={countries || []}
            />
            <Select
              onChange={(val) =>
                setQuery((st) => {
                  const next = { sort: st.sort, order: st.order };
                  if (st.country_id) next.country_id = st.country_id;
                  if (val) next.active = val;
                  return next;
                })
              }
              value={query.active || ""}
              field="name"
              label={translation.status}
              options={ACTIVE_FILTER_OPTIONS}
              isFieldTranslate
            />
          </div>
        }
        noDrag
        title={translation.dealer_codes}
        items={items}
        setItems={setItems}
        total={total}
        rows={rows}
        createLink="dealer-codes/create"
      />
    </WrapperSeamless>
  );
}
